module.exports = __webpack_public_path__ + "static/media/NTGS_Livestream.01ce4ab7.png";